import {
  getFileCategory,
  type EntityFile,
  type EntityNote,
  type FileCategory,
} from '@popety-io/ui'

export interface SharedNote {
  id?: string | number
  content?: string | null
  author_name?: string | null
  user_name?: string | null
  create_timestamp?: string | Date | null
}

export interface SharedFile {
  id?: string | number
  name?: string | null
  size?: number | null
  type?: string | null
  create_timestamp?: string | Date | null
}

export const toSharedEntityNotes = (
  notes: SharedNote[] | null | undefined
): EntityNote[] =>
  (notes || []).map((note) => {
    const author = note.author_name || note.user_name || undefined
    const id = typeof note.id === 'string' ? parseInt(note.id, 10) : note.id
    return {
      id: Number.isFinite(id) ? (id as number) : 0,
      content: note.content || '',
      userName: author,
      authorName: author,
      createdAt: note.create_timestamp
        ? new Date(note.create_timestamp).toISOString()
        : '',
    }
  })

export const toSharedEntityFiles = (
  files: SharedFile[] | null | undefined
): EntityFile[] =>
  (files || []).map((file) => {
    const name = file.name || ''
    const type = file.type || ''
    return {
      id: String(file.id ?? ''),
      name,
      original_name: name,
      size: file.size || 0,
      type,
      category: getFileCategory(type) as FileCategory,
      create_timestamp: file.create_timestamp
        ? new Date(file.create_timestamp).toISOString()
        : '',
    }
  })
